// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useContext } from 'react';
import { Theme } from '@mui/material';
import utilities from '../themes/bridge';
import { Branding } from '../utils/branding';

export type BrandingState = {
  branding: Branding;
  theme: Theme;
};

export const BrandingContext = React.createContext<BrandingState>(utilities);

export const useBranding: () => BrandingState = () => {
  const branding = useContext<BrandingState>(BrandingContext);
  return branding;
};
